import React from 'react'
import { string } from 'prop-types'

import styles from './EditorialIntro.module.scss'
import ChevronTitle from '../ChevronTitle'
import Prose from '../Prose'

const EditorialIntro = ({ description }) => (
  <div className={styles.EditorialIntro}>
    <ChevronTitle title="Editorial" className={styles.Title} />
    <Prose className={styles.Description} dangerousHtml={description} />
  </div>
)

EditorialIntro.propTypes = {
  description: string
}

export default EditorialIntro
